<template>
  <div class="estimate-template-new">
    <validation-observer class="validation-observer" v-slot="{ invalid }">
      <div class="title">見積書備考テンプレート登録</div>
      <div class="contents">
        <div class="content-wrap">
          <div class="heading">基本項目</div>
          <div class="content">
            <estimate-template-input-form
              class="input-form"
              :estimateTemplate="estimateTemplate"
            />
          </div>
        </div>
        <div class="button-wrap">
          <base-button-medium-white class="button" @click="goToListPage"
            >戻る</base-button-medium-white
          >
          <base-button-medium-orange
            class="button"
            v-if="lookOnlyFlg === 0"
            :disabled="invalid || waitFlg"
            @click="createData"
            >登録</base-button-medium-orange
          >
        </div>
      </div>
      <announce-popup
        v-if="popupFlg"
        :title="title"
        :buttons="buttons"
        :type="type"
        @close="closePopup"
        >{{ popupMessage }}</announce-popup
      >
    </validation-observer>
    <unsaved-leave-popup />
  </div>
</template>

<script>
import EstimateTemplateInputForm from '@/components/parts/organisms/EstimateTemplateInputForm'
import BaseButtonMediumWhite from '@/components/parts/atoms/BaseButtonMediumWhite'
import BaseButtonMediumOrange from '@/components/parts/atoms/BaseButtonMediumOrange'
import AnnouncePopup from '@/components/popups/AnnouncePopup'
import UnsavedLeavePopup from '@/components/popups/UnsavedLeavePopup'
import CheckInputDifference from '@/components/mixins/CheckInputDifference'
import { ValidationObserver } from 'vee-validate'
import { mapGetters } from 'vuex'

export default {
  name: 'EstimateTemplateNew',

  components: {
    EstimateTemplateInputForm,
    BaseButtonMediumWhite,
    BaseButtonMediumOrange,
    AnnouncePopup,
    UnsavedLeavePopup,
    ValidationObserver
  },

  mixins: [CheckInputDifference],

  data() {
    return {
      estimateTemplate: {
        name: '',
        content: ''
      },
      popupFlg: false,
      type: '',
      title: '',
      popupMessage: '',
      buttons: ['閉じる'],
      waitFlg: false
    }
  },

  computed: {
    ...mapGetters({
      lookOnlyFlg: 'auth/lookOnlyFlg'
    })
  },

  created() {
    this.mixinInputData = this.estimateTemplate
    this.mixinSetInitialData()
  },

  methods: {
    goToListPage() {
      this.$router.push({ name: 'estimate-templates' })
    },
    async createData() {
      this.waitFlg = true
      const result = await this.$store.dispatch(
        'estimateTemplates/create',
        this.estimateTemplate
      )
      if (result === true) {
        this.type = 'success'
        this.title = '完了'
        this.popupMessage = '新規登録しました'
        this.mixinSetInitialData()
      } else {
        this.type = 'failure'
        this.title = '失敗'
        this.popupMessage = '登録に失敗しました'
      }
      this.waitFlg = false
      this.popupFlg = true
    },
    closePopup() {
      this.popupFlg = false
      if (this.type === 'success') {
        this.$store.dispatch('petorelu/okLeave')
        this.goToListPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.estimate-template-new {
  > .validation-observer {
    > .title {
      font-size: 20px;
      font-weight: bold;
      border-bottom: 1px solid #{$light-grey};
      padding-bottom: 20px;
    }
    > .contents {
      margin-top: 20px;
      > .content-wrap {
        > .heading {
          font-size: 15px;
          font-weight: bold;
          border-bottom: 1px solid #{$light-grey};
          padding-bottom: 20px;
        }
        > .content {
          margin-top: 25px;
        }
      }
      > .button-wrap {
        display: flex;
        justify-content: center;
        margin: 60px 0;
        > .button {
          margin: 0 16px;
        }
      }
    }
  }
}
</style>
